import { CIcon } from '~/icons/types'

export const ciElectricScooter: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19.003 15.42 18 6.54l1.521-.47a.5.5 0 0 0-.296-.956l-3.558 1.102a.5.5 0 0 0 .148.977.488.488 0 0 0 .148-.022l1.065-.33.661 5.869-.004.004-3.445 4.16H7.399a2.01 2.01 0 1 0 0 1h7.077a.502.502 0 0 0 .385-.18l2.985-3.605.153 1.358a2.003 2.003 0 1 0 1.004-.025ZM5.459 18.384a1.01 1.01 0 1 1 1.01-1.01 1.011 1.011 0 0 1-1.01 1.01Zm13.082 0a1.01 1.01 0 1 1 1.01-1.01 1.011 1.011 0 0 1-1.01 1.01Z'
    },
    {
      d:
        'm6.958 10.35 1.346-.21-.828 2.898a.5.5 0 0 0 .881.436l4.313-5.75a.5.5 0 0 0-.468-.795l-1.445.202.806-1.811a.498.498 0 0 0-.042-.481.483.483 0 0 0-.43-.222L8.357 4.7a.5.5 0 0 0-.46.348L6.403 9.704a.499.499 0 0 0 .096.477.505.505 0 0 0 .458.17ZM8.74 5.69l1.585-.049-.849 1.906a.5.5 0 0 0 .058.504.51.51 0 0 0 .468.194l1.147-.16-1.97 2.626.3-1.05a.5.5 0 0 0-.481-.637.52.52 0 0 0-.078.006l-1.317.207Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'electric-scooter',
  type: 'thin'
}
